import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from 'web-library/stories/atom/FormControl/FormControl';
import { Box, CustomSelect } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { KeyValueResponse } from '../../api';
import * as QUERIES from '../../api/candidate/resit/@opadmin/queries-services/queries';
import { MenuItems } from './model';

const useStyles = makeStyles()((theme) =>
({
  formControlRoot: {
    width: '100%',
  },
}));

export interface EligibleSchoolsOptionProps {
  /** to handle select on change event
   * */
  onChange?: (event: KeyValueResponse) => void;

  /** to define select control selected value
   * */
  value: any;
}

/** React Component
 *  Reusable Organization Select Option
 * ** */
const EligibleOrganizationOptions: React.FC<EligibleSchoolsOptionProps> = (
  props: EligibleSchoolsOptionProps
) => {
  const { onChange = (event: KeyValueResponse) => null, value } = props;

  const { classes } = useStyles();

  const [schools, setSchools] = useState<KeyValueResponse[]>([]);
  const { t } = useTranslation();

  /** query to fetch organization
   * */
  QUERIES.useGetOopAdminOrganizationOptions({
    cacheTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (response) => {
      setSchools(response);
    },
  });

  /**
   * map organization data to [MenuItems]
   * */
  const organizationDropDownData = useMemo<MenuItems[]>(() => {
    if (!schools) {
      return [];
    }
    return schools.map((option) => ({
      children: option.description,
      value: option.code,
      key: `k-${option.code}`,
    }));
  }, [schools]);

  /** handle organization selected option change
   * */
  const onSelectedOptionChange = (selectedValue: any) => {
    if (schools && schools.length > 0) {
      const selectedOption = schools.find((school) => school.code === selectedValue);
      if (selectedOption) {
        onChange(selectedOption);
      }
    }
  };

  return (
    <Box>
      <FormControl id="organization-select-formcontrol" className={classes.formControlRoot}>
        <CustomSelect
          label={t('resit->>OpAdminResit.Organisations')}
          displayEmpty
          id="resit-organization-select"
          menuItems={organizationDropDownData}
          onChange={(e) => onSelectedOptionChange(e.target.value)}
          value={value}
          variant="filled"
        />
      </FormControl>
    </Box>
  );
};
export default EligibleOrganizationOptions;
